import styled from 'styled-components';

const Wrapper = styled.div`
  .openbarre {
    display: flex;
    justify-content: space-between;
    gap: 20px;
    width: 100%;
    background-color: white;
    z-index: 1000;
    padding: 15px;
    border-bottom: 3px solid #ff9900;

    * {
      font-size: 1.1rem;
    }

    @media (max-width: 800px) {
      align-items: center;

      * {
        font-size: 1rem;
      }
    }

    &:not(.openbarre--extended) {
      height: 70px;
      position: fixed;
      top: 0;
    }

    &--extended {
      height: 140px;

      @media (max-width: 800px) {
        height: 70px;
      }
    }

    &__left {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      gap: 12px;

      &--scrolled {
        flex-direction: row;
        align-items: center;
        gap: 20px;
      }

      @media (max-width: 800px) {
        flex-direction: row;
        align-items: center;
        gap: 12px;
      }

      &__logo {
        display: flex;
        align-items: center;
        justify-content: center;
        text-decoration: none;
        max-width: 200px;

        @media (max-width: 800px) {
          max-width: 100px;
        }

        &__img {
          width: 100%;
        }
      }

      &__nav {
        display: flex;
        gap: 10px;
        list-style: none;
        padding: 0;
        margin: 0;

        &__item {
          &__link {
            text-decoration: none;
            color: #707070;
            white-space: nowrap;
            transition: all 300ms;

            &:hover {
              text-decoration: underline;
              color: #252525;
            }
          }
        }
      }
    }

    &__right {
      display: flex;
      align-items: flex-end;
      flex-direction: column;
      justify-content: space-between;

      &--scrolled {
        flex-direction: row;
        align-items: center;
        gap: 20px;

        @media (max-width: 800px) {
          gap: 0;
        }
      }

      @media (max-width: 800px) {
        flex-direction: row;
        align-items: center;
      }

      &__top {
        display: flex;
        height: 32px;
        gap: 20px;

        &--scrolled {
          padding-right: 20px;
          border-right: 1px solid #bfbfbf;

          @media (max-width: 800px) {
            padding-right: 0;
            border-right: none;
          }
        }

        &__organization,
        &__language__button {
          display: flex;
          align-items: center;
          gap: 8px;
          opacity: 0.65;
          color: #252525;
          cursor: pointer;
          transition: all 300ms;

          &:hover {
            opacity: 1;
          }

          p {
            margin: 0;
          }
        }

        &__organization {
          padding-right: 20px;
          border-right: 1px solid #bfbfbf;
          text-decoration: none;

          &--scrolled {
            @media (max-width: 1050px) {
              display: none;
            }
          }

          @media (max-width: 800px) {
            display: none;
          }

          &:hover .openbarre__right__top__organization__name {
            text-decoration: underline;
          }

          &__icon {
            display: flex;
            align-items: center;
            justify-content: center;
            height: 28px;
            width: 28px;
            padding: 3px;
            border-radius: 5px;
            border: 1px solid #bfbfbf;

            &__img {
              width: 100%;
            }
          }
        }

        &__language {
          position: relative;
          display: flex;

          @media (max-width: 800px) {
            border-right: 1px solid #bfbfbf;
            padding-right: 10px;
            margin-right: 10px;
          }

          &:hover > .openbarre__right__top__language__dropdown {
            transform: scaleY(1);
          }

          &__button {
            background: none;
            border: none;
            padding: 0;

            &__icon {
              display: flex;
              align-items: center;
              justify-content: center;
              height: 28px;
              width: 28px;
            }
          }

          &__dropdown {
            position: absolute;
            top: 16px;
            transform: scaleY(0);
            transform-origin: top;
            background: white;
            box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
            border: 1px solid #bfbfbf;
            border-radius: 5px;
            padding: 10px;
            list-style: none;
            width: 100%;
            z-index: 10;
            transition: all 300ms;

            &.visible {
              transform: scaleY(1);
            }

            &__item {
              &__link {
                color: #252525;
                opacity: 0.9;
                text-decoration: none;
                cursor: pointer;
                transition: all 300ms;

                &:hover {
                  opacity: 1;
                  text-decoration: underline;
                }
              }
            }
          }
        }
      }

      &__bottom {
        position: relative;
        display: flex;
        flex-direction: column;
        align-items: flex-end;

        &:hover > .openbarre__right__bottom__menu {
          transform: scaleY(1);
        }

        p {
          margin: 0;
        }

        &__button {
          display: flex;
          align-items: center;
          gap: 8px;
          opacity: 0.65;
          cursor: pointer;
          transition: all 300ms;

          &:hover {
            opacity: 1;
          }
        }

        &__menu {
          position: absolute;
          display: flex;
          flex-direction: column;
          gap: 20px;
          top: 28px;
          transform: scaleY(0);
          transform-origin: top;
          background: white;
          box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
          border: 1px solid #bfbfbf;
          border-radius: 5px;
          overflow-y: auto;
          z-index: 10;
          max-height: 80vh;
          width: 100%;
          min-width: 260px;
          padding-bottom: 20px;
          transition: all 300ms;

          &__title {
            background: #707070;
            color: white;
            padding: 12px;
            margin: 0;
          }

          &__list {
            display: flex;
            flex-direction: column;
            gap: 4px;
            list-style: none;
            padding: 0 12px;
            margin: 0;

            &--organization {
              padding-top: 20px;

              &--scrolled {
                @media (min-width: 1051px) {
                  display: none;
                }
              }

              &:not(.openbarre__right__bottom__menu__list--organization--scrolled) {
                @media (min-width: 801px) {
                  display: none;
                }
              }
            }

            &__item {
              &__link {
                display: flex;
                gap: 8px;
                text-decoration: none;
                color: #252525;
                opacity: 0.8;
                width: fit-content;

                &:hover {
                  opacity: 1;
                  text-decoration: underline;
                }
              }
            }
          }

          &__icons {
            display: flex;
            align-items: center;
            gap: 8px;
            list-style: none;
            padding: 0 12px;
            margin: 0 0 -8px 0;

            &__item {
              &__link {
                opacity: 0.7;
                transition: all 300ms;

                &:hover {
                  opacity: 1;
                }
              }
            }
          }
        }
      }
    }
  }
`;

export { Wrapper };



// WEBPACK FOOTER //
// ./src/components/Header/style.js